import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import InviteUser from '../components/InviteUser';
import ServicerTable from './ServicerUserTable';
import { ListContainer } from 'components';
import { texts } from 'utils/languages/fr';
import { inviteFormType } from 'utils/constants';

const ServicerUsers = () => {
    return (
        <ListContainer>
            <Routes>
                <Route
                    path="invite-servicer"
                    element={
                        <InviteUser
                            title={texts.CREATE_SERVICER_USER}
                            type={inviteFormType.SERVICER}
                        />
                    }
                />
                <Route index element={<ServicerTable />} />
                <Route path="*" element={<Navigate to="/servicer-users" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default ServicerUsers;
